
















































































import { Component, Mixins, Prop, Watch, } from "vue-property-decorator";
import { TabContainableMixin } from "../../system/mixins";
import { ReceptionCommentSet, ReceptionComment } from "../../../domain/workflow/reception";
import { ReceptionCommentUnitKinds, ReceptionCommentKinds, ReceptionCommentSortItemKinds } from "../../../domain/workflow/kinds";
import TabSelector from "../../system/selectors/TabSelector.vue";
import CommentDialog from "../dialogs/CommentDialog.vue";
import CommentTable from "../lists/tables/controles/CommentTable.vue";
import { ReceptionDetailEditorCommentTabSelectorMixin } from "./mixins";

export interface ITabDefinition {
  name: string;
  description: string;
}

@Component({
  components: {
    TabSelector,
    CommentTable,
  },
})
export default class ReceptionDetailEditorCommentTabSelector extends Mixins(TabContainableMixin, ReceptionDetailEditorCommentTabSelectorMixin) {
  private Tabs: {[key: string]: ITabDefinition} = {
    nextMessage: {
      name: this.nextMessageTitle,
      description: "",
    },
    comment: {
      name: this.commentTitle,
      description: "",
    },
    restrictComment: {
      name: this.restrictCommentTitle,
      description: "",
    },
  };
  readonly nextMessageTab: ITabDefinition = this.Tabs.nextMessage;
  readonly commentTab: ITabDefinition = this.Tabs.comment;
  readonly restrictCommentTab: ITabDefinition = this.Tabs.restrictComment;

  @Prop()
  commentDialog: CommentDialog;

  @Prop()
  commentUnitKind: ReceptionCommentUnitKinds;

  @Prop()
  nextMessageUnitKind: ReceptionCommentUnitKinds;

  @Prop()
  restrictCommentUnitKind: ReceptionCommentUnitKinds;

  @Prop()
  commentDefaultSortType: ReceptionCommentSortItemKinds;

  @Prop()
  isNextMessageRegisterable: boolean;

  @Prop()
  isCommentRegisterable: boolean;

  @Prop()
  isRestrictCommentRegisterable: boolean;

  @Prop()
  shouldSortCommentAsc: boolean;

  data(): any {
    return {
      cancelButtonLabel: "中止する"
    };
  }
  cancelButtonLabel: string;

  async mounted(): Promise<void> {
    this.tabs = (this.isNextMessageRegisterable ? [this.Tabs.nextMessage] : [])
      .concat(this.isCommentRegisterable ? this.Tabs.comment : [])
      .concat(this.isRestrictCommentRegisterable ? this.Tabs.restrictComment : []);
    this.selectedTab = this.tabs.length > 0 ? this.tabs[0] : null;
    this.initializeSortTypes();
  }

  get nextMessageTitle(): string {
    return this.labelSetting
      ? this.labelSetting.nextMessageLabelName
      : "伝達事項";
  }

  get commentTitle(): string {
    return this.labelSetting
      ? this.labelSetting.commentLabelName
      : "コメント";
  }

  get restrictCommentTitle(): string {
    return this.labelSetting
      ? this.labelSetting.restrictCommentLabelName
      : "閲覧制限コメント";
  }

  get nextMessages(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.nextMessages
      : [];
  }

  get comments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.comments
      : [];
  }

  get restrictComments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.restrictComments
      : [];
  }

  get isCommentReadOnly(): boolean {
    return this.commentSet
      ? this.commentSet.isReadOnly
      : false;
  }

  getComments(commentKind: ReceptionCommentKinds): ReceptionComment[] {
    switch (commentKind) {
      case ReceptionCommentKinds.Comment:
        return this.comments;
      case ReceptionCommentKinds.NextMessage:
        return this.nextMessages;
      case ReceptionCommentKinds.Restrict:
        return this.restrictComments;
      default:
        return [];
    }
  }

  getUnitKind(commentKind: ReceptionCommentKinds): ReceptionCommentUnitKinds {
    switch (commentKind) {
      case ReceptionCommentKinds.Comment:
        return this.commentUnitKind;
      case ReceptionCommentKinds.NextMessage:
        return this.nextMessageUnitKind;
      case ReceptionCommentKinds.Restrict:
        return this.restrictCommentUnitKind;
      default:
        return null;
    }
  }

  showCommentDialog(kind: ReceptionCommentKinds, title: string, comment: ReceptionComment, commentSet: ReceptionCommentSet): void {
    (this.commentDialog)
      .show({
        name: title,
        note: (comment ? comment.content : ""),
        shouldEmphasizeInput: false,
        reference: commentSet
          ? {
            labelSetting: this.labelSetting,
            comments: {
              defaultSortType: this.commentDefaultSortType,
              shouldSortCommentAsc: this.shouldSortCommentAsc,
              nextMessages: {
                unit: this.nextMessageUnitKind,
                comments: commentSet.nextMessages,
              },
              backMessages: {
                unit: this.commentUnitKind,
                comments: commentSet.backMessages,
              },
            }
          }
          : null,
      })
      .then(d => {
        if (d.isConfirmed) {
          if (comment) {
            comment.content = d.note;
          } else {
            comment = new ReceptionComment();
            comment.content = d.note;
          }
          this.registerComment(kind, comment);
        }
      });
  }

  async confirmDeleteComment(kind: ReceptionCommentKinds): Promise<number> {
    return this.$commonDialogs.confirmation.show({
      title: "削除確認",
      message: [this.getCommentLabel(kind) + "を削除してもよろしいですか？"],
      buttons: [
        {
          kind: "danger",
          label: "削除する",
        }
      ],
      cancellation: {
        isEnable: true,
        label: this.cancelButtonLabel,
      },
    });
  }

  private initializeSortTypes(): void {
    this.nextMessageSortType = this.commentDefaultSortType;
    this.commentSortType = this.commentDefaultSortType;
    this.restrictCommentSortType = this.commentDefaultSortType;
  }

  @Watch("commentSet")
  onCommentSetUpdated() {
    this.initializeSortTypes();
  }
}
